// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styling */
.all-images-page {
    max-width: 1200px;
    margin: 20px auto; /* Added margin for top and bottom */
    padding: 20px;
    font-family: Arial, sans-serif;
    background-color: #f9f9f9;
  }
  
  .all-images-page h1 {
    text-align: center;
    font-size: 28px;
    margin-bottom: 30px;
    color: #343a40;
  }
  
  .section {
    margin-bottom: 40px;
  }
  
  .section h2 {
    font-size: 24px;
    margin-bottom: 15px;
    color: #007bff;
    border-bottom: 2px solid #ddd;
    padding-bottom: 5px;
  }
  
  /* Facebook Style Layout */
  .facebook-style-container {
    display: flex;
    flex-direction: column;
    gap: 20px; /* Space between items */
  }
  
  .facebook-style-item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    background: white;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    padding: 15px;
    gap: 20px; /* Space between image and content */
  }
  
  .facebook-style-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s, box-shadow 0.3s;
  }
  
  /* Image Styling */
  .facebook-style-image {
    max-width: 150px;
    max-height: 150px;
    border-radius: 5px;
    object-fit: cover;
    flex-shrink: 0; /* Prevent shrinking */
  }
  
  /* Content Styling */
  .content {
    flex-grow: 1;
  }
  
  .content h3 {
    font-size: 18px;
    color: #007bff;
    margin-bottom: 10px;
  }
  
  .content p {
    font-size: 14px;
    color: #666;
    margin-bottom: 0;
  }
  
  /* Interactive Section */
  .interactive-section {
    margin-top: 15px;
  }
  
  .like-dislike {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }
  
  .like-button,
  .dislike-button {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px;
    color: #007bff;
  }
  
  .like-button:hover,
  .dislike-button:hover {
    color: #0056b3;
  }
  
  .comment-box {
    width: 100%;
    height: 80px;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-bottom: 10px;
    resize: none;
  }
  
  .comment-submit-button {
    padding: 8px 15px;
    font-size: 14px;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .comment-submit-button:hover {
    background-color: #0056b3;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .facebook-style-item {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
  
    .facebook-style-image {
      max-width: 100%;
      max-height: 200px;
      margin-bottom: 15px;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/AllImagesPage.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,iBAAiB;IACjB,iBAAiB,EAAE,oCAAoC;IACvD,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA,0BAA0B;EAC1B;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAE,wBAAwB;EACrC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,SAAS,EAAE,oCAAoC;EACjD;;EAEA;IACE,2BAA2B;IAC3B,0CAA0C;IAC1C,2CAA2C;EAC7C;;EAEA,kBAAkB;EAClB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc,EAAE,sBAAsB;EACxC;;EAEA,oBAAoB;EACpB;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA,wBAAwB;EACxB;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,mBAAmB;IACrB;EACF","sourcesContent":["/* General Styling */\r\n.all-images-page {\r\n    max-width: 1200px;\r\n    margin: 20px auto; /* Added margin for top and bottom */\r\n    padding: 20px;\r\n    font-family: Arial, sans-serif;\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .all-images-page h1 {\r\n    text-align: center;\r\n    font-size: 28px;\r\n    margin-bottom: 30px;\r\n    color: #343a40;\r\n  }\r\n  \r\n  .section {\r\n    margin-bottom: 40px;\r\n  }\r\n  \r\n  .section h2 {\r\n    font-size: 24px;\r\n    margin-bottom: 15px;\r\n    color: #007bff;\r\n    border-bottom: 2px solid #ddd;\r\n    padding-bottom: 5px;\r\n  }\r\n  \r\n  /* Facebook Style Layout */\r\n  .facebook-style-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px; /* Space between items */\r\n  }\r\n  \r\n  .facebook-style-item {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: flex-start;\r\n    background: white;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    padding: 15px;\r\n    gap: 20px; /* Space between image and content */\r\n  }\r\n  \r\n  .facebook-style-item:hover {\r\n    transform: translateY(-5px);\r\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\r\n    transition: transform 0.3s, box-shadow 0.3s;\r\n  }\r\n  \r\n  /* Image Styling */\r\n  .facebook-style-image {\r\n    max-width: 150px;\r\n    max-height: 150px;\r\n    border-radius: 5px;\r\n    object-fit: cover;\r\n    flex-shrink: 0; /* Prevent shrinking */\r\n  }\r\n  \r\n  /* Content Styling */\r\n  .content {\r\n    flex-grow: 1;\r\n  }\r\n  \r\n  .content h3 {\r\n    font-size: 18px;\r\n    color: #007bff;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .content p {\r\n    font-size: 14px;\r\n    color: #666;\r\n    margin-bottom: 0;\r\n  }\r\n  \r\n  /* Interactive Section */\r\n  .interactive-section {\r\n    margin-top: 15px;\r\n  }\r\n  \r\n  .like-dislike {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .like-button,\r\n  .dislike-button {\r\n    border: none;\r\n    background: none;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    padding: 5px;\r\n    color: #007bff;\r\n  }\r\n  \r\n  .like-button:hover,\r\n  .dislike-button:hover {\r\n    color: #0056b3;\r\n  }\r\n  \r\n  .comment-box {\r\n    width: 100%;\r\n    height: 80px;\r\n    padding: 10px;\r\n    font-size: 14px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    margin-bottom: 10px;\r\n    resize: none;\r\n  }\r\n  \r\n  .comment-submit-button {\r\n    padding: 8px 15px;\r\n    font-size: 14px;\r\n    color: #fff;\r\n    background-color: #007bff;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .comment-submit-button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  /* Responsive Design */\r\n  @media (max-width: 768px) {\r\n    .facebook-style-item {\r\n      flex-direction: column;\r\n      align-items: center;\r\n      text-align: center;\r\n    }\r\n  \r\n    .facebook-style-image {\r\n      max-width: 100%;\r\n      max-height: 200px;\r\n      margin-bottom: 15px;\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
